import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const ProtectedRoute = (props) => {

    if (props.user.userinfo === null) {
        return <Navigate to="/notloggedin" />


    }
    else {
        console.log("hhh", props.allowedRoles)
        console.log(props.user.userinfo.userRoles.find((roles) => props.allowedRoles.includes(roles)))
        if (props.user.userinfo.userRoles.find((roles) => props.allowedRoles.includes(roles))) {
            return <Outlet />
        }
        else {
            return <Navigate to="/unauthorised" />
        }
    }

}

export default ProtectedRoute